import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {getAdvanceOptionRange as getAdvanceOptionRangeApi} from '../../../services/shareableCalendarViews'

export async function getAdvanceOptionRange(dispatch, action_id) {
  try {
    dispatch({type: PENDING})
    let response = await getAdvanceOptionRangeApi(action_id)
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Create Calendar View Failed: ${action_id}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
